import CoreBase from '../../../../services/engines/CoreBase';
import templateLoader from './TemplateLoader';

class WidgetInjector extends CoreBase {
    _name = 'WidgetInjector';

    /**
     * Loads a single widget body by rk and ensures it is wrapped in a <script> tag.
     * Wrapping happens here — widget notes don't need to know about HTML context.
     * Detects existing <script> tag via regex to handle comments, whitespace, etc.
     * @param {{ title: string, rk: string }} widget
     * @returns {string|null}
     */
    _loadWidget(widget) {
        const note = templateLoader.load(widget.rk);
        if (!note) {
            this.logError(`_loadWidget: not found — title=${widget.title} rk=${widget.rk}`);
            return null;
        }

        const body = note.body;

        // wrap in <script> als body geen <script> tag bevat
        // regex checkt op aanwezigheid — niet op positie — zodat comments vóór de tag ook werken
        const hasScriptTag = /<script[\s>]/i.test(body);
        if (!hasScriptTag) {
            return `<script>\n${body.trim()}\n</script>`;
        }

        return body;
    }

    /**
     * Resolves all widgets from templateJson.widgets[] via rk,
     * joins HTML/JS and injects before </body>.
     * Bails out if any widget fails to load.
     * @param {string} html
     * @param {object} templateJson
     * @returns {string|null} html with widgets injected or null on failure
     */
    inject(html, templateJson) {
        const widgets = templateJson?.widgets ?? [];

        const parts = [];
        for (const widget of widgets) {
            const body = this._loadWidget(widget);
            if (!body) return null;
            parts.push(body);
        }

        if (!parts.length) return html;

        return html.replace('</body>', `${parts.join('\n')}\n</body>`);
    }
}

const widgetInjector = new WidgetInjector();
export default widgetInjector;
